/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VmcDailyOrgSummaryPostSpec { 
    /**
     * vmc usage json
     */
    usage_json: { [key: string]: number; };
    org_id: string;
    /**
     * Date of the usage in YYYY-MM-DD.
     */
    usage_date: string;
}

